module.exports = __webpack_public_path__ + "static/img/far1_active.ec727fe3.png";